import { render, staticRenderFns } from "./DeleteVenueConfirmModal.vue?vue&type=template&id=85d54658&"
import script from "./DeleteVenueConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteVenueConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteVenueConfirmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports